<app-segment-list [segmentValue]="segmentValue()"
  [segmentButtons]="segmentButtons"
  (segmentChanged)="segmentChanged($event)"></app-segment-list>
@switch (segmentValue()) {
  @case ('main') {
    <div class="flex-wrap">
      <div>
        <div class="title">
          <h3>
            @if (ticket.nameText) {
              {{ ticket.nameText | translateField | async }}
            } @else {
              {{ ticket.name }}
            }
            @if (ticket.area.name != null) {
              ({{ ticket.area.name }})
        }
          </h3>
          @if (ticket.contractor) {
            {{ ticket.contractor.name }}<br />
          }
          @if (ticket.guid) {
            {{ 'tickets.taskId' | translate }}: {{ ticket.guid }}
          }
        </div>
      </div>
    </div>
    <ng-template #loadingUsers>
      <ion-button shape="round"
        color="light">
        <app-loading></app-loading>
      </ion-button>
    </ng-template>
    <div class="history">
      @for (item of history(); track item) {
        <div class="ticket-block">
          <div class="ticket-container-item">
            <div class="progress-border-container">
              <div class="progress-border">
                <ion-icon color="secondary"
                  name="ellipse"></ion-icon>
                <div class="border"></div>
              </div>
            </div>
            <div class="speech-container">
              <ion-item class="ticket"
                lines="none">
                <div class="ion-padding-bottom-05 full-width">
                  <div class="flex">
                    @if (item.images?.length > 0 || item.videos?.length > 0) {
                      <app-images [showCamera]="null"
                        [images]="item.images"
                        [videos]="item.videos"></app-images>
                    }
                  </div>
                  <div class="text-container">
                    <div class="badge-container">
                      @if (item.label) {
                        <ion-badge [color]="item.labelColor">
                          {{ 'kanban.label.' + item.label | translate }}
                        </ion-badge>
                      }
                    </div>
                    <div class="ion-margin-top">
                      <ion-note>
                        {{ item.timestamp | timestamp:'dd.MM.yyyy HH:mm' }}
                      </ion-note>
                    </div>
                    <h4>
                      @if (item.textText) {
                        {{ item.textText | translateField | async }}
                      } @else {
                        {{ item.text }}
                      }
                    </h4>
                    <div class="ticket-name">
                      @if (item.blockedBy) {
                        <div>
                          {{ 'tickets.createdNewTicket' | translate }} {{ item.blockedBy.name }}.
                        </div>
                      }
                      @if (item.status === 'created') {
                        <p>
                          @if (ticket.descriptionText) {
                            {{ ticket.descriptionText | translateField | async }}
                          } @else if (ticket.description) {
                            {{ ticket.description }}
                          } @else {
                            <span class="empty-description">
                              {{ 'item.noDescription' | translate }}
                            </span>
                          }
                        </p>
                        @if (ticket.hours) {
                          <ion-chip color="danger">
                            {{ 'tickets.reservedTime' | translate }}: {{ ticket.hours }}h
                          </ion-chip>
                        }
                        @if (ticket.deadline) {
                          <ion-chip color="danger">
                            {{ 'kanban.dateDeadline' | translate }}: {{ ticket.deadline | timestamp:'d.M.yyyy' }}
                          </ion-chip>
                        }
                        @if (ticket.schedule) {
                          <ion-chip color="danger">
                            {{ 'kanban.deadline' | translate }}:
                            {{ ticket.schedule.start | timestamp:'d.M. HH:mm' }} -
                            {{ ticket.schedule.end | timestamp:'d.M. HH:mm' }}
                          </ion-chip>
                        }
                      }
                      @if (item.commentText) {
                        <ion-note>{{ item.commentText | translateField | async }}</ion-note>
                      } @else if (item.comment) {
                        <ion-note>{{ item.comment }}</ion-note>
                      }
                    </div>
                    <div class="creator">
                      <ion-avatar>
                        @if (item.userImage; as image) {
                          <img [src]="image" />
                        } @else {
                          <ion-icon name="person-circle"></ion-icon>
                        }
                      </ion-avatar>
                      @if (item.username) {
                        <div>
                          {{ item.username }}
                          @if (item.creator?.phone) {
                            <br />{{ item.creator.phone }}
                          }
                          @if (item.creator?.email) {
                            <br />{{ item.creator.email }}
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </ion-item>
              @if (item.status === 'created' && !ticket.location) {
                <ion-item class="ticket"
                  lines="none">
                  <div class="ion-padding-bottom-05 full-width">
                    <div class="text-container map-container">
                      @if (map()) {
                        @if (imageElement()) {
                          <app-area-map [width]="475"
                            [height]="375"
                            [point]="map()"
                            [imgElement]="imageElement()"
                            (click)="onMap()"></app-area-map>
                        }
                      } @else {
                        <h4>{{ 'site.missingBlueprint' | translate }}</h4>
                        <div class="ticket-name">
                          {{ 'site.missingBlueprintText' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                </ion-item>
              }
            </div>
          </div>
        </div>
        @if (item.status === 'created' && ticket.location) {
          <div class="ticket-block">
            <div class="ticket-container-item">
              <div class="progress-border-container">
                <div class="progress-border">
                  <ion-icon color="secondary"
                    name="ellipse"></ion-icon>
                  <div class="border"></div>
                </div>
              </div>
              <div class="speech-container">
                <ion-item class="ticket"
                  lines="none">
                  <div class="ion-padding-bottom-05 full-width">
                    <div class="text-container">
                      @if (imageElement()) {
                        <app-fabric [imgElement]="imageElement()"
                          [points]="ticket.location"
                          [width]="500"
                          [height]="200"
                          [disabled]="true"
                          (click)="onMap()"></app-fabric>
                      }
                      <div class="badge-container">
                        @if (item.label) {
                          <ion-badge [color]="item.labelColor">
                            {{ 'kanban.label.' + item.label | translate }}
                          </ion-badge>
                        }
                      </div>
                    </div>
                  </div>
                </ion-item>
              </div>
            </div>
          </div>
        }
        @if (item.status === 'created' && ticket.status === 'created' && canManage()) {
          <div class="ticket-block">
            <div class="ticket-container-item">
              <div class="progress-border-container">
                <div class="progress-border">
                  <ion-icon color="secondary"
                    name="ellipse"></ion-icon>
                  <div class="border"></div>
                </div>
              </div>
              <div class="speech-container">
                <ion-item class="ticket"
                  lines="none">
                  <div class="ion-padding-bottom-05 full-width">
                    <div class="text-container">
                      <div class="badge-container">
                        @if (item.label) {
                          <ion-badge [color]="item.labelColor">
                            {{ 'kanban.label.' + item.label | translate }}
                          </ion-badge>
                        }
                      </div>
                      <h4>{{ 'tickets.handle' | translate }}</h4>
                      <ion-button color="primary"
                        (click)="onContractor()">
                        @if (isCommercial()) {
                          {{ 'tickets.assignCompany' | translate }}
                        } @else {
                          {{ 'tickets.assign' | translate }}
                        }
                      </ion-button>
                      <ion-button color="primary"
                        (click)="onInviteByEmail()">
                        {{ 'tickets.inviteByEmail' | translate }}
                      </ion-button>
                      <ion-button color="primary"
                        (click)="onAnswer()">
                        @if (managerRoles.includes(role())) {
                          {{ 'tickets.answer' | translate }}
                        } @else {
                          {{ 'tickets.answerCommercial' | translate }}
                        }
                      </ion-button>
                    </div>
                  </div>
                </ion-item>
              </div>
            </div>
          </div>
        }
      }
      <div class="ticket-block">
        <div class="ticket-container-item">
          <div class="progress-border-container">
            <div class="progress-border">
              <ion-icon color="secondary"
                name="ellipse"></ion-icon>
              <div class="border"></div>
            </div>
          </div>
          <div class="speech-container">
            <ion-item class="ticket"
              lines="none">
              <div class="ion-padding-bottom-05 full-width text-container">
                <div class="badge-container">
                  <ion-badge [color]="'light'">
                    {{ 'kanban.label.note' | translate }}
                  </ion-badge>
                </div>
                <div class="ion-margin-top">
                  <ion-note>
                    {{ today | timestamp:'dd.MM.yyyy' }}
                  </ion-note>
                </div>
                <h4>{{ 'tickets.writeComment' | translate }}</h4>
                <div></div>
                <div class="ticket-name">
                  <ion-item lines="none"
                    class="comment">
                    <ion-input autocapitalize="on"
                      #note
                      [placeholder]="'additionalInfo.comment' | translate"></ion-input>
                    <app-speech-to-text (text)="onMic($event, note)"></app-speech-to-text>
                  </ion-item>
                  <ion-button color="primary"
                    [disabled]="note.value?.toString().length === 0"
                    (click)="onNote(note)">
                    {{ 'tickets.saveComment' | translate }}
                  </ion-button>
                </div>
                <div class="creator">
                  <ion-avatar>
                    @if (user()?.image; as image) {
                      <img [src]="image" />
                    } @else {
                      <ion-icon name="person-circle"></ion-icon>
                    }
                  </ion-avatar>
                  @if (user()?.displayName; as name) {
                    <div>
                      {{ name }}
                    </div>
                  }
                </div>
              </div>
            </ion-item>
          </div>
        </div>
      </div>
    </div>
    } @case ('attachments') {
      <h3>{{ 'site.attachments' | translate }}</h3>
      <app-attachments [attachments]="ticket.attachments"
        [isReadOnly]="['worker'].includes(role())"
        [autoSave]="true"
        (save)="saveAttachment($event)"></app-attachments>
    } @case ('productInfo') {
      {{ 'home.coming' | translate }}
    } @case ('settings') {
      <div class="ion-margin-bottom">
        @if (companyAdminRoles.includes(role())) {
          <h4>{{ 'kanban.dateDeadline' | translate }}</h4>
          <app-select-day [color]="'light'"
            [format]="'d.M.'"
            [value]="ticket.deadline"
            (changed)="onDeadlineChange($event)"></app-select-day>
          @if (ticket.schedule) {
            <h4>{{ 'kanban.deadline' | translate }}</h4>
            <ion-button shape="round"
              color="light"
              expand="block">
              {{ ticket.schedule.start | timestamp:'d.M. HH:mm' }}<br />-<br />{{ ticket.schedule.end | timestamp:'d.M. HH:mm' }}
            </ion-button>
          }
        }
        @if (['contractor-admin'].includes(role())) {
          <h4>{{ 'calendar.site.duration' | translate }}</h4>
          <ion-button id="duration"
            color="secondary"
            expand="block"
            shape="round">
            @if (ticket.hours; as duration) {
              <span>
                {{ duration }}h
              </span>
            } @else {
              0h
            }
          </ion-button>
          @if ({
      users: users$ | async
    }; as usersVm) {
            <h4>{{ 'calendar.site.user' | translate }}</h4>
            <ion-button [disabled]="!(role() === 'contractor-admin')"
              shape="round"
              color="light"
              expand="block"
              (click)="selectWorker(usersVm.users)">
              @if (ticket.users?.length === 1) {
                <div>
                  {{ ticket.usernames[0] }}
                </div>
              } @else if (ticket.users?.length > 0) {
                {{ ticket.users.length }} {{ 'kanban.workers' | translate }}
              } @else {
                {{ 'kanban.chooseWorker' | translate }}
              }
            </ion-button>
          }
        }
        @if (ticket.area.name != null) {
          <h4>{{ 'calendar.site.area' | translate }}</h4>
          <ion-button color="light"
            shape="round"
            expand="block"
            (click)="selectRoom()">
            <div>
              {{ ticket.area.name }}
            </div>
          </ion-button>
        }
      </div>
      @if (adminsAndManagers.includes(role())) {
        <h4>{{ 'nav.materials.manage' | translate }}</h4>
        <ion-button color="light"
          expand="block"
          (click)="onEditName(ticket)">
          {{ 'site.ai.newName' | translate }}
        </ion-button>
        <ion-button color="light"
          expand="block"
          (click)="onEditDescription(ticket)">
          {{ 'calendar.site.edit.description' | translate }}
        </ion-button>
      }
      <ion-modal #durationModal
        class="picker-modal"
        trigger="duration"
        [keepContentsMounted]="true">
        <ng-template>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-button (click)="durationModal.dismiss()">
                {{ 'general.cancel' | translate }}
              </ion-button>
            </ion-buttons>
            <ion-buttons>
              <ion-button color="danger"
                (click)="onDuration(0); durationModal.dismiss()">
                {{ 'general.reset' | translate }}
              </ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
              <ion-button (click)="onDuration(durationPicker.value); durationModal.dismiss()">
                {{ 'general.select' | translate }}
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
          <ion-picker>
            <ion-picker-column #durationPicker
              [value]="ticket.hours">
              @for (duration of pickerColumns; track duration.value) {
                <ion-picker-column-option [value]="duration.value">{{ duration.text }}</ion-picker-column-option>
              }
            </ion-picker-column>
          </ion-picker>
        </ng-template>
      </ion-modal>
      @if (canDelete()) {
        <div>
          <ion-button shape="round"
            color="danger"
            (click)="onDelete()">
            {{ 'general.delete' | translate }}
          </ion-button>
        </div>
      }
    } @case ('images') {
      @for (item of images(); track $index) {
        <div class="ion-margin-bottom">
          <app-image-item [item]="item"
            (klick)="onImage(item.image)"></app-image-item>
        </div>
      }
      @for (media of videos(); track $index) {
        @if (media.type === 'image') {
          <img class="link media"
            [src]="media.url"
            (click)="onImage(media.url)" />
        } @else if (media.type === 'video') {
          <video class="link media"
            preload="metadata"
            controls
            playsinline>
            <source [src]="media.url + '#t=0.5'"
              type="video/mp4">
          </video>
        }
      }
      <div class="flex-center">
        <app-camera-button class="only-camera"
          [name]="ticket.name"
          color="light"
          fill="clear"
          [multiline]="true"
          (imageUrl)="onImageUrl($event)"></app-camera-button>
        <app-take-video class="only-camera"
          [name]="ticket.name"
          color="light"
          fill="clear"
          [multiline]="true"
          (imageUrl)="videoUrl($event)"></app-take-video>
      </div>
    }
    }
    @if (segmentValue() === 'main') {
      @if (residentsAndAdminsAndManagers.includes(role())) {

      } @else {
        <div class="footer">
          <div>
            <div class="to-progress">
              @if ([statuses.created, statuses.paused].includes(ticket.status)) {
                <ion-button shape="round"
                  (click)="toProgress()">
                  {{ 'kanban.toProgress' | translate }}
                </ion-button>
              }
              @if (ticket.status === statuses.inProgress) {
                <ion-button shape="round"
                  (click)="toDone()">
                  {{ 'kanban.toDone' | translate }}
                </ion-button>
              }
              @if (ticket.status === statuses.done) {
                <ion-button shape="round"
                  color="tertiary"
                  (click)="toProgress(true)">
                  {{ 'kanban.backProgress' | translate }}
                </ion-button>
              }
              @if (ticket.status === statuses.inProgress) {
                <ion-button shape="round"
                  color="tertiary"
                  (click)="toBacklog()">
                  {{ 'kanban.toBacklog' | translate }}
                </ion-button>
              }
              @if (ticket.status === statuses.inProgress) {
                <app-block-button [ticket]="ticket"
                  [siteGuid]="ticket.site"
                  (save)="toBlocked(ticket.site, $event)">
                </app-block-button>
              }
              @if (ticket.status === statuses.blocked) {
                <ion-button shape="round"
                  (click)="toProgress(false, true)">
                  {{ 'kanban.continue' | translate }}
                </ion-button>
              }
              @if (role() === 'super-admin' && ticket.status === statuses.paused) {
                <ion-button shape="round"
                  color="tertiary"
                  (click)="removePaused()">
                  {{ 'kanban.removePaused' | translate }}
                </ion-button>
              }
            </div>
          </div>
        </div>
      }
    }